import styled from '@emotion/styled';
import { mainColors, formLabel } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';
import { Label } from 'src/domains/layouts/shared/typography/Content.style';

interface InputLabelPropsType {
    isEmpty?: boolean;
}

export const InputLabel = styled(Label, { label: 'InputLabel' })<InputLabelPropsType>`
    color: ${({ isEmpty }): string => isEmpty === true ? formLabel.txtColor : formLabel.txtColorSecondary};
    font-size: ${fontSize.small};
    margin: 0 0 8px 0;
`;

export const ErrorMessage = styled('div', { label: 'ErrorMessage' })`
    font-family: var(--fontFamilyPrimary);
    font-size: ${fontSize.xRegular};
    font-weight: ${fontWeight.regular};
    line-height: 1.4;
    color: ${mainColors.status.error};
    margin: 8px 0;
`;

export const ErrorMessageBar = styled(ErrorMessage, { label: 'ErrorMessageBar' })`
    flex: 1 0 100%;
    background-color: ${mainColors.status.error};
    color: ${mainColors.default.light};
    margin: 15px 0;
    padding: 5px 15px;
`;

export const InputError = styled(ErrorMessage, { label: 'InputError' })`
    font-size: ${fontSize.small};
    flex: 1 0 100%;
    margin: 8px 0 0 0;
`;

export const InfoHint = styled('div', { label: 'InfoHint' })`
    font-family: var(--fontFamilyPrimary);
    font-size: ${fontSize.small};
    font-weight: ${fontWeight.medium};
    color: ${mainColors.grays.gray400};
    background: ${mainColors.grays.gray100};
    border-radius: 4px;
    margin-bottom: 8px;
    padding: 8px;
    width: fit-content;
`;


export const InputLabelInside = styled('label', { label: 'InputLabelInside' })`
    color: ${mainColors.grays.gray400};
    left: 12px;
    top: 5px;
    font-family: var(--fontFamilyPrimary);
    font-size: ${fontSize.xSmall};
    font-weight: ${fontWeight.regular};
    line-height: 1.3334;
    pointer-events: none;
    position: absolute;
    user-select: none;
    white-space: nowrap;
`;
